import React, {useState} from "react";
import { Button, Column, Columns, Field, Modal, Section } from "@allxsmith/bestax-bulma";
import useInput from "../../hooks/useInput";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";

export default function MultipleEditModalCustomer({
  open,
  setOpen,
  selected,
  saveSelected,
  trackingOptions,
  trackingObjects,
  nominalCodes,
  codeObject
}) {
  const [invoiceNumber, invoiceNumberInput, setInvoiceNumber] = useInput({
    type: "text",
    label: "Invoice Number"
  });

  const [invoiceDate, invoiceDateInput] = useInput({
    type: "date",
    label: "Invoice Date"
  });

  const [workTrackingOption, setWorkTrackingOption] = useState();
  const [workNominalCode, setWorkNominalCode] = useState();

  const [partTrackingOption, setPartTrackingOption] = useState();
  const [partNominalCode, setPartNominalCode] = useState();

  const onTrackingOptionChange = (e, setFunc) => {
    setFunc(trackingObjects[e.target.value]);
  }

  const onNominalCodeChange = (e, setFunc) => {
    setFunc(codeObject[e.target.value]);
  }

  const onSave = () => {
    saveSelected(invoiceNumber, null, workTrackingOption, workNominalCode, partTrackingOption, partNominalCode, invoiceDate).then(onClose);
  };

  const onClose = () => {
    setOpen(false);
    setInvoiceNumber("");
    setWorkTrackingOption(undefined);
    setWorkNominalCode(undefined);
    setPartTrackingOption(undefined);
    setPartNominalCode(undefined);
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal closeOnBlur active={open} onClose={onClose}>
      <Modal.Content className={"wider-modal"}>
        <Section style={{ backgroundColor: "white" }}>
          <Columns isMultiline>
            {invoiceNumberInput}
            {invoiceDateInput}
            <Column>
              <TrackingOptionsPicker
                name={"customer_tracking_option"}
                label={"Work Tracking Option"}
                value={workTrackingOption}
                options={trackingOptions}
                blank={true}
                className={"not-small"}
                inlineEdit={false}
                editable={true}
                onChange={(e) => onTrackingOptionChange(e, setWorkTrackingOption)}
              />
            </Column>
            <Column>
              <TrackingOptionsPicker
                name={"customer_tracking_option"}
                label={"Part Tracking Option"}
                value={partTrackingOption}
                options={trackingOptions}
                blank={true}
                className={"not-small"}
                inlineEdit={false}
                editable={true}
                onChange={(e) => onTrackingOptionChange(e, setPartTrackingOption)}
              />
            </Column>
            <Column>
              <NominalCodePicker
                name={"customer_nominal_code"}
                label={"Work Nominal code"}
                value={workNominalCode}
                options={nominalCodes}
                blank={true}
                small={false}
                inlineEdit={false}
                editable={true}
                onChange={(e) => onNominalCodeChange(e, setWorkNominalCode)}
              />
            </Column>
            <Column>
              <NominalCodePicker
                name={"customer_nominal_code"}
                label={"Part Nominal code"}
                value={partNominalCode}
                options={nominalCodes}
                blank={true}
                small={false}
                inlineEdit={false}
                editable={true}
                onChange={(e) => onNominalCodeChange(e, setPartNominalCode)}
              />
            </Column>
          </Columns>
          <Field>
            <p>You are editing {Object.keys(selected).length} work items</p>
          </Field>
          <Columns>
            <Column>
              <Button color="success" onClick={onSave}>
                Save
              </Button>
            </Column>
            <Column>
              <Button color="info" onClick={() => setOpen(false)}>
                Cancel
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
